import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import Dropdown from 'components/cosmos/dropdown';
import Icon from 'components/icons';
import { ReactComponent as BadgeDollar } from 'components/svg/icons/badge-dollar.svg';
import { ReactComponent as CloseCosmos } from 'components/svg/icons/close-cosmos.svg';
import { ReactComponent as DeleteIcon } from 'components/svg/icons/delete-lg.svg';
import { ReactComponent as DuplicateCosmos } from 'components/svg/icons/duplicate-cosmos.svg';
import { ReactComponent as Duplicate } from 'components/svg/icons/duplicate-sm.svg';
import { ReactComponent as EllipsisVertical } from 'components/svg/icons/ellipsis-vertical.svg';
import { ReactComponent as PenToSquare } from 'components/svg/icons/pen-to-square.svg';
import { I18n, translate } from 'components/translate';
import { BASE_MODULE, MODULE_ADVERTISEMENT } from 'configs/routes/constants';
import { withShellContext } from 'hoc/withShellContext';
import intersectionWith from 'lodash/intersectionWith';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { CATEGORIES, LABELS, ACTIONS } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import { SeasonService } from 'modules/content';
import ContentCreateActions from 'modules/content/components/sortable/ContentCreateActions';
import { ITEM_TYPE } from 'modules/content/constants';
import { FeatureToggles } from 'modules/featureToggle';
import MembershipService from 'modules/membership/MembershipService';
import PropTypes from 'prop-types';

import DraggableContent from './DraggableContent';
import DropableService from './DropableService';
import EditAction from './editAction';
import { moduleEditUrl } from './editAction/utils';
import FlagsList from './FlagsList';

import ContentEvents from '../../events';

@withRouter
@translate()
@withShellContext
@inject((stores) => ({
  onboarding: stores.ContentOnboardingStore,
  isOnlineEvent: stores.MembershipStore.onlineEvent,
  createModuleConceptEnabled: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.CreateModuleConcept
  )
}))
export default class ModuleType extends Component {
  static propTypes = {
    isMembership: PropTypes.bool,
    history: PropTypes.object,
    item: PropTypes.object,
    index: PropTypes.number,
    updateModuleName: PropTypes.func,
    onBlurModuleNameHandler: PropTypes.func,
    renderModuleFlags: PropTypes.func,
    objItemIdClasses: PropTypes.object,
    getClassTooltipContent: PropTypes.func,
    clearClassTooltipContent: PropTypes.func,
    checkedContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isExtra: PropTypes.bool,
    isMobile: PropTypes.bool,
    closedDroppable: PropTypes.bool,
    moduleName: PropTypes.array,
    checkAllpages: PropTypes.func,
    isModuleDragging: PropTypes.bool,
    isPageDragging: PropTypes.bool,
    isDraggingOver: PropTypes.bool,
    expandModules: PropTypes.bool,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    onDuplicate: PropTypes.func,
    checkboxChange: PropTypes.func,
    classesList: PropTypes.array,
    isClassesLoaded: PropTypes.bool,
    isLast: PropTypes.bool,
    items: PropTypes.object,
    urlWithParams: PropTypes.func,
    moduleHandleKeyPress: PropTypes.func,
    t: PropTypes.func,
    onboarding: MobxPropTypes.objectOrObservableObject,
    isOnlineEvent: PropTypes.bool,
    updateModulesOpen: PropTypes.func,
    openModulesList: PropTypes.array,
    showModalMass: PropTypes.func,
    updateCheckedModule: PropTypes.func
  };

  state = {
    actionDropdownOpened: false
  };

  static defaultProps = {
    itemsLength: 0,
    isOnlineEvent: false
  };

  actionDropdownRef = React.createRef();

  shouldComponentUpdate(nextProps) {
    return (
      !DropableService.isItemsEqual(this.props.items, nextProps.items) ||
      DropableService.isToogleModules(
        this.props.expandModules,
        nextProps.expandModules
      ) ||
      this.props.checkedContent.nPublishedModules ===
        nextProps.checkedContent.nPublishedModules
    );
  }

  isModuleChecked(id) {
    const { checkedContent } = this.props;
    const modulesCheckeds = checkedContent && checkedContent.modules;

    if (modulesCheckeds && modulesCheckeds.length) {
      return modulesCheckeds.includes(id);
    }

    return false;
  }

  isEqualPage(module, id) {
    return id === module.id;
  }

  checkedPages(id) {
    const { checkedContent, items } = this.props;

    const item = items.find((element) => {
      return element.id === id;
    });

    const pages = intersectionWith(
      item.pages,
      checkedContent.pages,
      this.isEqualPage
    );

    return { pages, item };
  }

  isAtLeastOnePageChecked(id) {
    const { pages } = this.checkedPages(id);

    return pages.length > 0;
  }

  isAllPagesChecked(id) {
    const { pages, item } = this.checkedPages(id);

    return item.totalPages && pages.length === item.totalPages;
  }

  isNeedPulsedCheckBoxModule() {
    const { onboarding } = this.props;

    return (
      onboarding.showVersionWithOnboarding &&
      onboarding.checkList.hasModule &&
      onboarding.checkList.hasContent &&
      !onboarding.checkList.publishedContent
    );
  }

  renderModuleDropdown(itemId) {
    const {
      item,
      isExtra,
      isMobile,
      isMembership,
      urlWithParams,
      createModuleConceptEnabled
    } = this.props;
    const season = MembershipService.hasSeason
      ? SeasonService.getSelectedSeasonInfo()?.id ?? null
      : null;
    const isModuleEmpty = item.totalPages === 0;
    const shouldShowDuplicateButton = !isModuleEmpty;

    const editionUrl = moduleEditUrl({
      season,
      isMembership,
      urlWithParams,
      moduleId: item.id,
      createModuleConceptEnabled,
      isExtraModule: item.extra,
      isPaidModule: item.paidModule
    });

    return isMobile ? (
      <Dropdown>
        <button
          slot="button"
          data-test="button-ellipis-vertical"
          className="_w-7"
        >
          <EllipsisVertical />
        </button>
        <Dropdown.MenuHeader className="_p-5">
          <span className="_d-flex _justify-content-between">
            <h3 className="_text-3 _text-gray-700 _mb-0 dropdown-header">
              {item.name}
            </h3>
            <CloseCosmos
              data-test="close-icon"
              className="_cursor-pointer"
              onClick={Dropdown.closeMenu}
            />
          </span>
        </Dropdown.MenuHeader>

        <Dropdown.MenuItem className="_pl-5 _pr-5 _pt-4 _pb-4">
          <Link
            data-test="c-button-edit-module"
            to={editionUrl}
            className="draggable-link"
            onClick={() => {
              ContentEvents.sendModuleEvent({ label: 'Edit' });

              DatahubService.sendEvent({
                action: EVENT_ACTIONS.INTERACT,
                event: buildInteractionEventData({
                  category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.NAME,
                  label: EVENTS_LABELS.CONTENT.MANAGE_MODULE.EDIT,
                  action: EVENTS_INTERACTIONS.CLICK
                })
              });
            }}
          >
            <button className="_d-flex _justify-content-between _align-items-center _w-full">
              <div className="_d-flex _align-items-center">
                <PenToSquare className="edit-icon" />
                <p className="_mb-0 _mt-0 _ml-2 _text-2 _text-gray-700">
                  <I18n label="general.edit" />
                </p>
              </div>
            </button>
          </Link>
        </Dropdown.MenuItem>
        {shouldShowDuplicateButton && (
          <Dropdown.MenuItem className="_pl-5 _pr-5 _pt-4 _pb-4">
            <button
              className="_d-flex _justify-content-between _align-items-center _w-full"
              onClick={this.onDuplicate}
            >
              <div className="_d-flex _align-items-center">
                <DuplicateCosmos className="duplicate-icon _ml-1" />
                <p className="_mb-0 _mt-0 _ml-4 _text-2 _text-gray-700">
                  <I18n label="general.duplicate" />
                </p>
              </div>
            </button>
          </Dropdown.MenuItem>
        )}

        <Dropdown.MenuItem className="_pl-5 _pr-5 _pt-4 _pb-4">
          <button
            className="_d-flex _justify-content-between _align-items-center _w-full"
            onClick={this.onDelete}
          >
            <div className="_d-flex _align-items-center">
              <DeleteIcon className="delete-icon _mb-1" />
              <p className="_mb-0 _mt-0 _ml-3 _text-2 _text-gray-700">
                <I18n label="general.exclude" />
              </p>
            </div>
          </button>
        </Dropdown.MenuItem>

        <Dropdown.MenuDivider className="_ml-5 _mr-5" />

        <Dropdown.MenuHeader className="_pl-5 _pr-5 _pb-4">
          <h4 className="_text-2 _text-gray-500 _pt-4">
            <I18n label="general.add" />
          </h4>
        </Dropdown.MenuHeader>

        <ContentCreateActions
          itemId={itemId}
          isExtra={isExtra}
          selectedSeason={season}
          urlWithParams={urlWithParams}
          contentNewURL={this.contentNewURL}
          onCreateContentEvents={this.handleCreateContentEvents}
        />
      </Dropdown>
    ) : (
      this.renderDraggableModuleActions(itemId, editionUrl)
    );
  }

  contentNewURL = ({ itemId, itemType, isExtra, selectedSeason }) => {
    const { urlWithParams } = this.props;

    const url = `${BASE_MODULE}/${itemId}/${itemType}/new`;

    return urlWithParams(url, { extra: isExtra, season: selectedSeason });
  };

  onDelete = () => {
    const { showModalMass, updateCheckedModule, item } = this.props;

    updateCheckedModule && updateCheckedModule(item.id);

    showModalMass && showModalMass();
  };

  onDuplicate = async () => {
    const { item, onDuplicate } = this.props;

    GtagService.sendClick({
      category: CATEGORIES.CLUB_ADMIN_CONTENT,
      where: ACTIONS.DUPLICATION_CONTENT.MODULE,
      label: LABELS.DUPLICATION_CONTENT.DUPLICATE_MODULE
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.DUPLICATION_CONTENT.MODULE,
        label: EVENTS_LABELS.DUPLICATION_CONTENT.DUPLICATE_MODULE,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });

    onDuplicate && onDuplicate(item.id, item.name, item.classes);
  };

  handleCreateAdvertisement = () => {
    this.handleCreateContentEvents(EVENTS_LABELS.CONTENT.MANAGE_MODULE.ADS);
  };

  handleCreateContentEvents = (label, eventParams) => {
    ContentEvents.sendCreateEvent({ label });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        label,
        action: EVENTS_INTERACTIONS.CLICK,
        category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.CREATE_CONTENT,
        ...eventParams
      })
    });
  };

  onCloseActionDropdown = () => {
    this.setState({ actionDropdownOpened: false });
  };

  onOpenActionDropdown = () => {
    this.setState({ actionDropdownOpened: true });
  };

  renderDraggableModuleActions(itemId, editionUrl) {
    const { index, isExtra, item, urlWithParams } = this.props;
    const { actionDropdownOpened } = this.state;
    const type = ITEM_TYPE.MODULE;
    const selectedSeason = MembershipService.hasSeason
      ? SeasonService.getSelectedSeasonInfo()?.id ?? null
      : null;
    const isModuleEmpty = item.totalPages === 0;
    const shouldShowDuplicateButton = !isModuleEmpty;

    return (
      <>
        <div className={`draggable-actions ${type}-actions`}>
          <EditAction itemId={item.id} index={index} editionUrl={editionUrl} />

          {shouldShowDuplicateButton && (
            <button
              className="hot-button hot-button--secondary hot-button--sm _mr-2"
              id={`duplicate-module-${itemId}`}
              onClick={this.onDuplicate}
            >
              <Duplicate className="duplicate-icon" />
              <I18n label="general.duplicate" />
            </button>
          )}

          <Link
            className="draggable-link hot-button hot-button--secondary hot-button--sm _mr-2 _text-blue-dark"
            to={this.contentNewURL({
              itemId,
              isExtra,
              selectedSeason,
              itemType: MODULE_ADVERTISEMENT
            })}
            onClick={this.handleCreateAdvertisement}
          >
            <BadgeDollar className="ad-icon" />
            <I18n label="advertisement_editor.create_advertisement" />
          </Link>

          <Dropdown
            menuSide={Dropdown.MENU_SIDE.RIGHT}
            onClose={this.onCloseActionDropdown}
            onOpen={this.onOpenActionDropdown}
            ref={this.actionDropdownRef}
          >
            <button
              className="hot-button hot-button--secondary hot-button--sm"
              slot="button"
            >
              <I18n label="general.add" />
              <Icon
                prefix="fas"
                iconName="caret-down"
                className={classNames('_ml-1', {
                  'caret-icon__rotate': actionDropdownOpened
                })}
              />
            </button>

            <ContentCreateActions
              itemId={itemId}
              isExtra={isExtra}
              selectedSeason={selectedSeason}
              urlWithParams={urlWithParams}
              contentNewURL={this.contentNewURL}
              onCreateContentEvents={this.handleCreateContentEvents}
            />
          </Dropdown>
        </div>
      </>
    );
  }

  onCheckModule = (event) => {
    const { checkboxChange } = this.props;

    ContentEvents.sendModuleEvent({ label: 'CheckAllPages' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.NAME,
        label: EVENTS_LABELS.CONTENT.MANAGE_MODULE.CHECK_ALL_PAGES,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });

    checkboxChange && checkboxChange(event);
  };

  onMouseUp = (e) => {
    const { onMouseUp } = this.props;

    ContentEvents.sendModuleEvent({ label: 'OrderModule' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.NAME,
        label: EVENTS_LABELS.CONTENT.MANAGE_MODULE.ORDER_MODULE,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });

    onMouseUp && onMouseUp(e);
  };

  render() {
    const {
      item,
      index,
      updateModuleName,
      onBlurModuleNameHandler,
      renderModuleFlags,
      getClassTooltipContent,
      clearClassTooltipContent,
      checkedContent,
      moduleName,
      checkAllpages,
      checkboxChange,
      isMobile,
      isExtra,
      onMouseDown,
      isDraggingOver,
      expandModules,
      isModuleDragging,
      isPageDragging,
      isLast,
      moduleHandleKeyPress,
      updateModulesOpen,
      openModulesList
    } = this.props;

    const type = ITEM_TYPE.MODULE;
    const draggableClass = classNames(`draggable-${type}`);
    const isChecked = Boolean(
      this.isModuleChecked(item.id) || this.isAllPagesChecked(item.id)
    );
    const checkboxModuleId = `checkbox-select-module_${item.id}`;

    moduleName[index] = item.name;

    return (
      <DraggableContent
        checkAll={isChecked}
        checkedContent={checkedContent}
        checkAllpages={checkAllpages}
        checkboxChange={checkboxChange}
        isMobile={isMobile}
        isExtra={isExtra ? isExtra : false}
        index={index}
        type={type}
        item={item}
        id={item.id}
        className={draggableClass}
        expandModules={expandModules}
        isModuleDragging={isModuleDragging}
        isPageDragging={isPageDragging}
        isDraggingOver={isDraggingOver}
        dragOnMouseUp={this.onMouseUp}
        dragOnMouseDown={onMouseDown}
        updateModulesOpen={updateModulesOpen}
        openModulesList={openModulesList}
      >
        <div className="module-header">
          <div className="content-list-name">
            <div className="hot-form hot-form--custom hot-form--checkbox">
              <input
                type="checkbox"
                className={classNames('hot-form__input', {
                  'check__container--pulsed': this.isNeedPulsedCheckBoxModule()
                })}
                id={checkboxModuleId}
                checked={isChecked}
                onChange={this.onCheckModule}
                data-module={item.id}
                data-published={item.published}
              />
              <label
                className="hot-form__label"
                htmlFor={checkboxModuleId}
                aria-label={item.name}
              />
            </div>
            <input
              onKeyPress={moduleHandleKeyPress}
              onChange={(e) => updateModuleName(e.target.value, index)}
              onClick={() => {
                ContentEvents.sendModuleEvent({ label: 'EditTitle' });

                DatahubService.sendEvent({
                  action: EVENT_ACTIONS.INTERACT,
                  event: buildInteractionEventData({
                    category: EVENTS_CATEGORY.CONTENT.MANAGE_MODULE.NAME,
                    label: EVENTS_LABELS.CONTENT.MANAGE_MODULE.EDIT_TITLE,
                    action: EVENTS_INTERACTIONS.CLICK
                  })
                });
              }}
              value={moduleName[index] || item.name}
              className="content-list-name-input"
              data-module={item.id}
              onBlur={onBlurModuleNameHandler}
              maxLength="100"
              type="text"
            />
          </div>
          <div className={`draggable-options ${type}-options`}>
            {this.renderModuleDropdown(item.id)}
          </div>
        </div>
        <FlagsList
          renderModuleFlags={renderModuleFlags}
          getClassTooltipContent={getClassTooltipContent}
          isMobile={isMobile}
          clearClassTooltipContent={clearClassTooltipContent}
          isLast={isLast}
          item={item}
        />
      </DraggableContent>
    );
  }
}
